import { create } from 'zustand';

export interface DFCCClubFilterObject {
	search: string;
	sortValue: string;
	town: string;
}

export type DfccClubSortValue = 'createddate_desc' | 'createddate_asc' | '';

const initialDfccClubFilterObject: DFCCClubFilterObject = {
	search: '',
	sortValue: '',
	town: '',
};

interface DfccClubFilterStore {
	dfccClubFilterObject: DFCCClubFilterObject;
	search: string;
	sortValue: DfccClubSortValue;
	updateDfccClubFilterObject: (filter: DFCCClubFilterObject) => void;
	updateDfccClubSearch: (search: string) => void;
	updateDfccClubSortValue: (sortValue: DfccClubSortValue) => void;
	resetDfccClubFilterStore: () => void;
}

export const useDFCCClubFilterStore = create<DfccClubFilterStore>((set) => ({
	dfccClubFilterObject: { ...initialDfccClubFilterObject },
	search: '',
	sortValue: '',
	updateDfccClubFilterObject: (filter: DFCCClubFilterObject): void =>
		set(() => ({ dfccClubFilterObject: { ...filter } })),
	updateDfccClubSearch: (search): void => set(() => ({ search })),
	updateDfccClubSortValue: (sortValue): void => set(() => ({ sortValue })),
	resetDfccClubFilterStore: (): void =>
		set(() => ({
			dfccClubFilterObject: { ...initialDfccClubFilterObject },
			search: '',
			sortValue: '',
		})),
}));
